import { render, staticRenderFns } from "./MaterialList.vue?vue&type=template&id=47c10fc0&"
import script from "./MaterialList.vue?vue&type=script&lang=js&"
export * from "./MaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports